import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { IGetOfferDataResponseSchema } from '@cian/api-models/offer-card/v1/get-offer-data';
import { IState } from '../../store';
import { chatMessageSent } from '../../store/offer_chats';
import { setPhoneCollapse } from '../../store/phone_collapse';
import { toggle as toggleCallbackPopup } from '../../store/popups/callback';
import { isABAgentExperienceExperiment } from '../../utils/ab_agent_experience';
import { Author, IAuthorProps } from './index';
import { showCountrysideBuilderBadge } from '../../utils/suburban';

type TAuthorProps = Pick<
  IAuthorProps,
  | 'abGroup'
  | 'agent'
  | 'developer'
  | 'offer'
  | 'offerChat'
  | 'user'
  | 'kp'
  | 'isAgentExperienceExperimentActive'
  | 'isDealRequestSubstitutionPhone'
  | 'showCountrysideBuilderBadge'
>;
type TOfferData = Pick<IGetOfferDataResponseSchema, 'agentAvailability' | 'agentReviews'>;
type TDispatchProps = Pick<IAuthorProps, 'openCallbackPopup' | 'setPhoneCollapse' | 'chatMessageSent'>;
type TStoreProps = TAuthorProps & TOfferData;

export function mapStateToProps(state: IState): TStoreProps {
  return {
    abGroup: state.abGroup,
    agent: state.offerData.agent,
    agentAvailability: state.offerData.agentAvailability,
    agentReviews: state.offerData.agentReviews,
    developer: state.offerData.newObject && state.offerData.newObject.developer,
    isAgentExperienceExperimentActive: isABAgentExperienceExperiment(state.experiments),
    kp: state.offerData.kp,
    offer: state.offerData.offer,
    offerChat: state.offerChat,
    user: state.offerData.user,
    isDealRequestSubstitutionPhone: state.offerData.offer.isDealRequestSubstitutionPhone,
    showCountrysideBuilderBadge: showCountrysideBuilderBadge(state),
  };
}

export function mapDispatchToProps(dispatch: Dispatch<IState>): TDispatchProps {
  return {
    chatMessageSent: () => dispatch(chatMessageSent()),
    openCallbackPopup: () => dispatch(toggleCallbackPopup('agent', true)),
    setPhoneCollapse: () => dispatch(setPhoneCollapse()),
  };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const AuthorContainer = connect<TStoreProps, TDispatchProps, any>(mapStateToProps, mapDispatchToProps)(Author);
